/* ------------------------------------*\
    #INTERACTION-LAYER SCRIPT
\*------------------------------------ */

import Dialog from '../../../../../src/js/components/dialog';

/**
 * The interaction layer is a specific overlay component that obscures content while not acting modally.
 * @class InteractionLayer
 * @extends Dialog
 */
class InteractionLayer extends Dialog {

    static componentName = 'interaction-layer';

    static componentSelector = 'dialog.c-interaction-layer';

    // EXTEND DEFAULTS
    static defaultOptions = Dialog.extendDefaultOptions({
        triggerSelector: '.js-interaction-layer-trigger',
        closeSelector: '.js-interaction-layer-close',
        openEventName: 'bronson_interaction-layer_open',
        closeEventName: 'bronson_interaction-layer_close',
        cancelEventName: 'bronson_interaction-layer_cancel',
    });

    // eslint-disable-next-line no-useless-constructor
    constructor() {
        super(...arguments);
    }

}

InteractionLayer.register();

export default InteractionLayer;
